import axios from 'axios';
import { url } from 'api';

// Proposta dinâmica (24/10/2026) — chamadas à api da Central.
// 29/10/2026: cenários, pagamento composto, minuta, "virar venda".

const dados = (p) => p.then((r) => r.data);

export const catalogo = () => dados(axios.get(`${url}/propostas/catalogo`));
export const negocio = (dealId) => dados(axios.get(`${url}/propostas/negocio/${dealId}`));
export const calcular = (corpo) => dados(axios.post(`${url}/propostas/calcular`, corpo));
export const criar = (corpo) => dados(axios.post(`${url}/propostas`, corpo));
export const salvarVersao = (id, corpo) => dados(axios.put(`${url}/propostas/${id}`, corpo));
export const gerar = (id) => dados(axios.post(`${url}/propostas/${id}/gerar`));
export const aprovar = (id) => dados(axios.post(`${url}/propostas/${id}/aprovar`));
export const renovar = (id) => dados(axios.post(`${url}/propostas/${id}/renovar`));
export const virarVenda = (id, corpo) => dados(axios.post(`${url}/propostas/${id}/virar-venda`, corpo || {}));
export const detalhe = (id) => dados(axios.get(`${url}/propostas/${id}`));
export const listar = (filtro) => dados(axios.get(`${url}/propostas`, { params: filtro }));

/** Abre um PDF da api (com o token da sessão) numa aba nova. */
export const abrirPdf = async (caminho) => {
  const r = await axios.get(`${url}${caminho}`, { responseType: 'blob' });
  const blob = new Blob([r.data], { type: 'application/pdf' });
  const link = URL.createObjectURL(blob);
  window.open(link, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(link), 60000);
};
export const abrirMinuta = (plano) => abrirPdf(`/propostas/minuta/${plano}`);

export const mensagemDoErro = (error) => {
  const d = error && error.response && error.response.data;
  if (d && d.errors && typeof d.errors === 'object') {
    const primeiro = Object.values(d.errors)[0];
    if (primeiro) return Array.isArray(primeiro) ? primeiro[0] : primeiro;
  }
  return (d && d.message) || 'Não foi possível concluir. Tente de novo.';
};

const reais0 = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
const reais2 = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const brl = (c) => {
  const v = (c || 0) / 100;
  return Number.isInteger(v) ? reais0.format(v) : reais2.format(v);
};
export const brl2 = (c) => reais2.format((c || 0) / 100);
export const pct = (v) => `${String(Number(v || 0).toFixed(2)).replace(/\.?0+$/, '').replace('.', ',')}%`;

/** "1.500" ou "1500,50" (como o vendedor digita) → centavos. */
export const paraCentavos = (texto) => {
  const t = String(texto || '').trim();
  if (!t) return 0;
  const limpo = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t;
  return Math.round((parseFloat(limpo) || 0) * 100);
};

export const dataHora = (iso) => (iso
  ? new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
  : '');
export const data = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '');

export const tempo = (s) => {
  if (!s) return '—';
  const m = Math.floor(s / 60);
  const r = s % 60;
  return m ? `${m}m${String(r).padStart(2, '0')}s` : `${r}s`;
};

export const STATUS = {
  rascunho: { rotulo: 'rascunho', cor: '#9A6700', fundo: '#FFF4DD' },
  aguardando_aprovacao: { rotulo: 'aguardando aprovação', cor: '#9A6700', fundo: '#FFF4DD' },
  enviada: { rotulo: 'enviada', cor: '#42455F', fundo: '#F1F0F4' },
  aberta: { rotulo: 'aberta', cor: '#1F9833', fundo: '#E8F5EA' },
  aceita: { rotulo: 'aceita', cor: '#FFFFFF', fundo: '#1F9833' },
  vencida: { rotulo: 'vencida', cor: '#DB0A3C', fundo: '#FDE8EE' },
};

export const NOME_MEIO = { pix: 'Pix', cartao: 'cartão', boleto: 'boleto' };

export const mensagemWhatsapp = ({ cliente, vendedor, calculo, link }) => {
  const primeiro = (cliente || '').split(' ')[0] || '';
  const h = calculo.honorarios || {};
  const pagamento = (h.pagamento && h.pagamento.descricao) || (h.parcelas > 1 ? `${h.parcelas}x de ${brl2(h.parcela)}` : 'pagamento à vista');
  const cenarios = (calculo.cenarios || []).length;
  return `Olá${primeiro ? `, ${primeiro}` : ''}! Aqui é ${vendedor || 'a equipe'}, da Cidadania Já. `
    + `Preparei a proposta da cidadania portuguesa para você: honorários de ${brl(h.total)} (${pagamento})`
    + `${cenarios > 1 ? `, com ${cenarios} cenários para você comparar` : ''}, `
    + `com os custos de cartório e conservatória detalhados por etapa. Veja aqui: ${link} `
    + `(vale ${calculo.validade_dias} dias). Qualquer dúvida, me chama por aqui.`;
};
